import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, Play, Bell, Menu, X, Home, Flame, Zap, Plus, User, Clock, ThumbsUp, ListVideo, History,
  Bookmark, Users, Music2, Briefcase, GraduationCap, Cpu, Film, Gamepad2, Newspaper, Trophy, Radio,
  ChevronDown, LogOut, LayoutDashboard, UtensilsCrossed, Plane, Laugh, Mic2, Moon, Sun, Clapperboard, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { DASHBOARD_HOME } from "../../context/AuthContext";

export const MP_CSS = `
.mp-root{--mp-bg:#07110E;--mp-panel:#10251E;--mp-ink:#e8f2ec;--mp-mut:rgba(232,242,236,.55);--mp-line:rgba(255,255,255,.07);--mp-pillbg:#12291F;background:var(--mp-bg);color:var(--mp-ink);min-height:100vh}
.mp-panel{background:var(--mp-panel);border:1px solid var(--mp-line)}
.mp-green{background:#00E676;color:#04150e}
.mp-green:hover{background:#34f591}
.mp-pill{border-radius:999px;background:var(--mp-pillbg);color:var(--mp-mut);font-weight:700;font-size:12.5px;padding:7px 14px;white-space:nowrap;transition:background .15s,color .15s;flex-shrink:0}
.mp-pill:hover{background:var(--mp-line)}
.mp-pill.on{background:#00E676;color:#04150e}
.mp-thumb{border-radius:14px;overflow:hidden;position:relative;background:var(--mp-pillbg)}
.mp-side-link{display:flex;align-items:center;gap:14px;padding:9px 12px;border-radius:10px;font-size:13.5px;font-weight:600;color:var(--mp-mut);transition:background .15s}
.mp-side-link:hover{background:var(--mp-line)}
.mp-side-link.on{background:var(--mp-line);color:var(--mp-ink)}
.mp-scroll::-webkit-scrollbar{width:8px;height:8px}
.mp-scroll::-webkit-scrollbar-thumb{background:var(--mp-pillbg);border-radius:8px}
.mp-card:hover .mp-thumb img{transform:scale(1.04)}
.mp-thumb img{transition:transform .3s ease}
.mp-snap{scroll-snap-type:y mandatory}
.mp-snap>*{scroll-snap-align:start;scroll-snap-stop:always}
@keyframes mp-fade{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
.mp-fade{animation:mp-fade .35s ease both}

/* ================= LIGHT MODE ================= */
.mp-light{--mp-bg:#f6faf7;--mp-panel:#ffffff;--mp-ink:#0b1510;--mp-mut:rgba(11,21,16,.55);--mp-line:rgba(11,21,16,.1);--mp-pillbg:#e9f2ec}
.mp-light .text-white{color:var(--mp-ink)!important}
.mp-light .text-white\\/35,.mp-light .text-white\\/40,.mp-light .text-white\\/45,.mp-light .text-white\\/50,.mp-light .text-white\\/55{color:var(--mp-mut)!important}
.mp-light .text-white\\/60,.mp-light .text-white\\/65{color:rgba(11,21,16,.62)!important}
.mp-light .text-white\\/70,.mp-light .text-white\\/80,.mp-light .text-white\\/85{color:rgba(11,21,16,.75)!important}
.mp-light .placeholder\\:text-white\\/35::placeholder{color:var(--mp-mut)!important}
.mp-light .bg-white\\/10,.mp-light .bg-white\\/\\[0\\.06\\],.mp-light .bg-white\\/\\[0\\.07\\],.mp-light .bg-white\\/\\[0\\.08\\]{background:rgba(11,21,16,.06)!important}
.mp-light .bg-white\\/\\[0\\.1\\],.mp-light .bg-white\\/\\[0\\.14\\],.mp-light .bg-white\\/\\[0\\.16\\]{background:rgba(11,21,16,.1)!important}
.mp-light .hover\\:bg-white\\/10:hover,.mp-light .hover\\:bg-white\\/\\[0\\.14\\]:hover,.mp-light .hover\\:bg-white\\/\\[0\\.16\\]:hover,.mp-light .hover\\:bg-white\\/\\[0\\.1\\]:hover{background:rgba(11,21,16,.09)!important}
.mp-light .border-white\\/10,.mp-light .border-white\\/\\[0\\.07\\],.mp-light .border-white\\/\\[0\\.08\\]{border-color:var(--mp-line)!important}
.mp-light .border-white\\/15{border-color:rgba(11,21,16,.16)!important}
.mp-light .bg-\\[\\#070b09\\],.mp-light .bg-\\[\\#070b09\\]\\/95,.mp-light .bg-\\[\\#070b09\\]\\/97{background:rgba(247,250,248,.96)!important}
.mp-light .bg-\\[\\#0a0f0d\\]{background:#ffffff!important}
.mp-light .bg-\\[\\#101a14\\]{background:#ffffff!important;border-color:var(--mp-line)}
.mp-light .bg-\\[\\#16221c\\]{background:var(--mp-pillbg)!important}
.mp-light .hover\\:bg-\\[\\#1a2b22\\]:hover{background:#dcebe2!important}
.mp-light .bg-\\[\\#0e1512\\]{background:#ffffff!important}
/* keep white text on image/video overlays in both modes */
.mp-light .mp-kw .text-white,.mp-light .mp-kw.text-white{color:#fff!important}
.mp-light .mp-kw .text-white\\/50,.mp-light .mp-kw .text-white\\/60,.mp-light .mp-kw .text-white\\/70{color:rgba(255,255,255,.78)!important}
`;

export const VID_CSS = MP_CSS;

export const MP_PILLS = ["All", "Music", "Mixes", "Business", "Technology", "Education", "Food", "Travel", "Comedy", "Gaming", "News", "Sports", "Live"];

export const MP_CATS = [
  { name: "Music", icon: Music2 }, { name: "Movies", icon: Film }, { name: "Business", icon: Briefcase },
  { name: "Education", icon: GraduationCap }, { name: "Technology", icon: Cpu }, { name: "Food", icon: UtensilsCrossed },
  { name: "Travel", icon: Plane }, { name: "Gaming", icon: Gamepad2 }, { name: "Comedy", icon: Laugh },
  { name: "News", icon: Newspaper }, { name: "Sports", icon: Trophy }, { name: "Live", icon: Radio },
];

export const timeAgo = (d) => {
  if (!d) return "";
  const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  if (s < 2592000) return `${Math.floor(s / 604800)}w ago`;
  return `${Math.floor(s / 2592000)}mo ago`;
};

export const fmtViews = (n) => {
  n = Number(n || 0);
  if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  return `${n}`;
};

export const getMPTheme = () => { try { return localStorage.getItem("mp_theme") || "dark"; } catch { return "dark"; } };

export function ThemeToggle() {
  const [light, setLight] = useState(getMPTheme() === "light");
  const toggle = () => {
    const next = !light;
    setLight(next);
    try { localStorage.setItem("mp_theme", next ? "light" : "dark"); } catch { /* ignore */ }
    window.dispatchEvent(new Event("mp_theme"));
  };
  return (
    <button onClick={toggle} data-testid="mp-theme-toggle" title={light ? "Switch to Dark Mode" : "Switch to Light Mode"}
      className="h-9 w-9 rounded-full bg-white/[0.08] hover:bg-white/[0.14] flex items-center justify-center text-white/80 transition-colors">
      {light ? <Moon className="h-[18px] w-[18px]" /> : <Sun className="h-[18px] w-[18px]" />}
    </button>
  );
}

export function MPlayLogo({ onClick }) {
  return (
    <button onClick={onClick} className="flex items-center gap-2 shrink-0" data-testid="mplay-logo">
      <span className="h-8 w-8 rounded-[10px] flex items-center justify-center shadow-lg shadow-emerald-500/25"
        style={{ background: "linear-gradient(135deg,#4ade80,#16a34a)" }}>
        <Play className="h-4.5 w-4.5 h-[18px] w-[18px] text-[#04150e] fill-[#04150e] ml-0.5" />
      </span>
      <span className="font-extrabold tracking-tight text-white text-[19px]">M<span className="text-emerald-400">Play</span></span>
    </button>
  );
}

export function TopNav({ onMenu }) {
  const [q, setQ] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mSearch, setMSearch] = useState(false);
  const submit = (e) => { e.preventDefault(); if (q.trim()) { navigate(`/videos?q=${encodeURIComponent(q.trim())}`); setMSearch(false); } };
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#07110E]/95 backdrop-blur border-b border-white/[0.07]" data-testid="mplay-topnav">
      <div className="h-[60px] flex items-center gap-3 px-3 sm:px-5">
      <button className="lg:hidden shrink-0 text-white/80 h-10 w-10 flex items-center justify-center rounded-full hover:bg-white/10" onClick={onMenu} data-testid="mp-burger"><Menu className="h-5 w-5" /></button>
      <Link to="/videos"><MPlayLogo /></Link>
      <form onSubmit={submit} className="flex-1 max-w-[560px] mx-auto hidden sm:flex items-center">
        <div className="flex-1 flex items-center bg-[#10251E] border border-white/10 rounded-full overflow-hidden focus-within:border-emerald-500/50">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search videos, channels, topics…"
            className="flex-1 bg-transparent px-5 h-10 text-sm text-white placeholder:text-white/35 outline-none" data-testid="mp-search" />
          <button type="submit" className="h-10 w-14 flex items-center justify-center bg-white/[0.06] hover:bg-white/10 transition-colors" data-testid="mp-search-btn">
            <Search className="h-4.5 w-4.5 h-[18px] w-[18px] text-white/70" />
          </button>
        </div>
      </form>
      <button className="sm:hidden ml-auto shrink-0 text-white/80 h-10 w-10 flex items-center justify-center rounded-full hover:bg-white/10"
        onClick={() => setMSearch((v) => !v)} data-testid="mp-search-mobile" aria-label="Search"><Search className="h-5 w-5" /></button>
      <div className="ml-auto sm:ml-0 flex items-center gap-1.5 sm:gap-2.5">
        <Link to={user?.role === "CREATOR" ? "/creator/videos/new" : "/creator/join"} data-testid="mp-create"
          className="hidden sm:flex items-center gap-1.5 h-9 px-4 rounded-full bg-white/[0.08] hover:bg-white/[0.14] text-white text-[13px] font-bold transition-colors">
          <Plus className="h-4 w-4" /> Create
        </Link>
        <button className="h-9 w-9 rounded-full hover:bg-white/10 flex items-center justify-center text-white/80" data-testid="mp-bell"><Bell className="h-[18px] w-[18px]" /></button>
        <ThemeToggle />
        {user ? (
          <div className="relative">
            <button onClick={() => setMenuOpen(!menuOpen)} data-testid="mp-avatar"
              className="h-9 w-9 rounded-full flex items-center justify-center overflow-hidden text-[13px] font-extrabold text-[#04150e]" style={{ background: "linear-gradient(135deg,#4ade80,#16a34a)" }}>
              {user.creator?.avatar
                ? <img src={user.creator.avatar} alt={user.name} className="h-full w-full object-cover" />
                : (user.name || "U")[0].toUpperCase()}
            </button>
            {menuOpen && (
              <div className="absolute right-0 top-11 w-52 mp-panel rounded-xl shadow-2xl p-1.5 z-50" data-testid="mp-user-menu">
                <Link to={DASHBOARD_HOME[user.role] || "/creator"} onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-[13px] font-semibold text-white/85 hover:bg-white/10"><LayoutDashboard className="h-4 w-4" /> Dashboard</Link>
                {user.role === "CREATOR" && (
                  <>
                    <Link to={`/channel/${user.creator?.slug || ""}`} onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-[13px] font-semibold text-white/85 hover:bg-white/10" data-testid="mp-my-channel"><User className="h-4 w-4" /> My Channel</Link>
                    <Link to="/creator/profile" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-[13px] font-semibold text-white/85 hover:bg-white/10" data-testid="mp-channel-settings"><SettingsIcon className="h-4 w-4" /> Channel Settings</Link>
                  </>
                )}
                <Link to="/" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-[13px] font-semibold text-white/85 hover:bg-white/10"><Home className="h-4 w-4" /> MILTROO Home</Link>
              </div>
            )}
          </div>
        ) : (
          <>
            <Link to="/mkt/auth?mode=login&returnTo=/videos" data-testid="mp-login"
              className="h-9 px-3 sm:px-4 rounded-full bg-white/[0.08] hover:bg-white/[0.14] text-white text-[13px] font-bold flex items-center gap-1.5 transition-colors shrink-0">
              <User className="h-4 w-4" /> Sign in
            </Link>
            <Link to="/creator/login" data-testid="mp-creator-login"
              className="h-9 px-3 sm:px-4 rounded-full text-[13px] font-extrabold flex items-center gap-1.5 text-[#04150e] transition-transform active:scale-95 shrink-0"
              style={{ background: "linear-gradient(135deg,#4ade80,#16a34a)" }}>
              <Clapperboard className="h-4 w-4" /> <span className="hidden min-[420px]:inline">Creator</span>
            </Link>
          </>
        )}
      </div>
      </div>
      {mSearch && (
        <form onSubmit={submit} className="sm:hidden flex items-center gap-2 px-3 pb-2.5" data-testid="mp-search-mobile-bar">
          <div className="flex-1 flex items-center bg-[#10251E] border border-emerald-500/50 rounded-full overflow-hidden">
            <input value={q} onChange={(e) => setQ(e.target.value)} autoFocus placeholder="Search videos or creators"
              className="flex-1 bg-transparent px-4 h-10 text-sm text-white placeholder:text-white/35 outline-none" data-testid="mp-search-mobile-input" />
            <button type="submit" className="h-10 w-12 flex items-center justify-center text-white/70" data-testid="mp-search-mobile-go" aria-label="Search">
              <Search className="h-[18px] w-[18px]" />
            </button>
          </div>
          <button type="button" onClick={() => setMSearch(false)} aria-label="Close search"
            className="h-10 w-10 flex items-center justify-center rounded-full text-white/70 hover:bg-white/10" data-testid="mp-search-mobile-close">
            <X className="h-5 w-5" />
          </button>
        </form>
      )}
    </header>
  );
}

export function SideNav({ open, onClose }) {
  const loc = useLocation();
  const { user } = useAuth();
  const [showCats, setShowCats] = useState(false);
  const isOn = (p) => loc.pathname + loc.search === p || loc.pathname === p;
  const main = [
    { to: "/videos", label: "Home", icon: Home },
    { to: "/videos/shorts", label: "Shorts", icon: Zap },
    { to: "/videos/following", label: "Following", icon: Users },
  ];
  const you = [
    { to: "/videos/library", label: "History", icon: History },
    { to: "/videos/library?tab=playlists", label: "Playlists", icon: ListVideo },
    { to: user?.role === "CREATOR" ? "/creator/videos" : "/videos/library", label: "Your videos", icon: Play },
    { to: "/videos/library?tab=later", label: "Watch later", icon: Clock },
    { to: "/videos/library?tab=liked", label: "Liked videos", icon: ThumbsUp },
  ];
  const body = (
    <div className="h-full overflow-y-auto mp-scroll py-3 px-2.5">
      {main.map((m) => (
        <Link key={m.label} to={m.to} onClick={onClose} data-testid={`mp-side-${m.label.toLowerCase()}`}
          className={`mp-side-link ${isOn(m.to) ? "on" : ""}`}>
          <m.icon className="h-[19px] w-[19px]" /> {m.label}
        </Link>
      ))}
      <p className="px-3 pt-4 pb-1 text-[13px] font-bold text-white">You</p>
      {you.map((m) => (
        <Link key={m.label} to={m.to} onClick={onClose} data-testid={`mp-side-${m.label.toLowerCase().replace(/\s+/g, "-")}`} className="mp-side-link">
          <m.icon className="h-[19px] w-[19px]" /> {m.label}
        </Link>
      ))}
      <p className="px-3 pt-4 pb-1 text-[13px] font-bold text-white">Categories</p>
      {(showCats ? MP_CATS : MP_CATS.slice(0, 8)).map((c) => (
        <Link key={c.name} to={`/videos?category=${encodeURIComponent(c.name)}`} onClick={onClose} data-testid={`mp-side-cat-${c.name.toLowerCase()}`} className="mp-side-link">
          <c.icon className="h-[19px] w-[19px]" /> {c.name}
        </Link>
      ))}
      <button onClick={() => setShowCats(!showCats)} className="mp-side-link w-full" data-testid="mp-side-more">
        <ChevronDown className={`h-[19px] w-[19px] transition-transform ${showCats ? "rotate-180" : ""}`} /> {showCats ? "Show less" : "Show more"}
      </button>
      <div className="mt-4 mx-3 pt-4 border-t border-white/[0.07]">
        <Link to="/" className="mp-side-link text-emerald-400" data-testid="mp-side-miltroo"><Home className="h-[19px] w-[19px]" /> MILTROO Home</Link>
      </div>
    </div>
  );
  return (
    <>
      <aside className="hidden lg:block fixed left-0 top-[60px] bottom-0 w-[212px] bg-[#070b09] border-r border-white/[0.07] z-40" data-testid="mplay-sidebar">{body}</aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-[60]">
          <div className="absolute inset-0 bg-black/70" onClick={onClose} />
          <aside className="absolute left-0 top-0 bottom-0 w-[240px] bg-[#0a0f0d] border-r border-white/10 z-10">
            <div className="flex items-center justify-between px-4 h-[60px] border-b border-white/[0.07]">
              <Link to="/videos" onClick={onClose}><MPlayLogo /></Link>
              <button onClick={onClose} className="text-white/70"><X className="h-5 w-5" /></button>
            </div>
            {body}
          </aside>
        </div>
      )}
    </>
  );
}

export function MobileNav() {
  const loc = useLocation();
  const { user } = useAuth();
  const items = [
    { to: "/videos", label: "Home", icon: Home, on: loc.pathname === "/videos" && !loc.search },
    { to: "/videos/shorts", label: "Shorts", icon: Zap, on: loc.pathname === "/videos/shorts" },
    { to: user?.role === "CREATOR" ? "/creator/videos/new" : "/creator/join", label: "", icon: Plus, create: true },
    { to: "/videos/following", label: "Following", icon: Users, on: loc.pathname === "/videos/following" },
    { to: "/videos/library", label: "Library", icon: Bookmark, on: loc.pathname === "/videos/library" },
  ];
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[#070b09]/97 backdrop-blur border-t border-white/[0.08] pb-[env(safe-area-inset-bottom)]" data-testid="mplay-mobilenav">
      <div className="grid grid-cols-5">
        {items.map((it, i) => it.create ? (
          <Link key="create" to={it.to} data-testid="mp-mnav-create" className="flex items-center justify-center">
            <span className="h-11 w-11 rounded-full flex items-center justify-center text-[#04150e] shadow-lg shadow-emerald-500/30" style={{ background: "linear-gradient(135deg,#4ade80,#16a34a)" }}>
              <Plus className="h-6 w-6" />
            </span>
          </Link>
        ) : (
          <Link key={it.label} to={it.to} data-testid={`mp-mnav-${it.label.toLowerCase()}`}
            className={`flex flex-col items-center gap-1 py-2 text-[10px] font-bold ${it.on ? "text-emerald-400" : "text-white/55"}`}>
            <it.icon className="h-5 w-5" />{it.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}

export function Pills({ active, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto mp-scroll pb-1 -mx-1 px-1" data-testid="mplay-pills">
      {MP_PILLS.map((p) => (
        <button key={p} onClick={() => onChange(p === "All" ? "" : p)} data-testid={`mp-pill-${p.toLowerCase()}`}
          className={`mp-pill ${(active || "") === (p === "All" ? "" : p) ? "on" : ""}`}>{p}</button>
      ))}
    </div>
  );
}

const avatarBg = (name) => {
  const hues = [145, 200, 160, 25, 260, 190];
  const h = hues[(name || "M").length % hues.length];
  return `linear-gradient(135deg, hsl(${h} 60% 42%), hsl(${h + 30} 55% 30%))`;
};

export function Avatar({ name, size = 34, src = "" }) {
  if (src) {
    return <img src={src} alt={name || "avatar"} loading="lazy" className="rounded-full object-cover shrink-0"
      style={{ width: size, height: size }} data-testid="mp-avatar-img" />;
  }
  return (
    <span className="rounded-full flex items-center justify-center font-extrabold text-white shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.42, background: avatarBg(name) }} data-testid="mp-avatar-img">
      {(name || "M")[0].toUpperCase()}
    </span>
  );
}

export function VCard({ v, small }) {
  return (
    <Link to={`/v/${v.slug}`} className="mp-card group block" data-testid={`mp-vcard-${v.id}`}>
      <div className="mp-thumb aspect-video">
        {v.thumbnail_url
          ? <img src={v.thumbnail_url} alt={v.title} loading="lazy" className="h-full w-full object-cover" />
          : <div className="h-full w-full flex items-center justify-center"><Play className="h-9 w-9 text-white/20 fill-white/20" /></div>}
        <span className="mp-kw absolute bottom-2 right-2 bg-black/80 text-white text-[11px] font-bold px-1.5 py-0.5 rounded-md tabular-nums">{fmtViews(v.views)} views</span>
        {v.is_short && <span className="absolute top-2 left-2 bg-black/70 text-emerald-400 text-[10px] font-extrabold px-2 py-0.5 rounded-md flex items-center gap-1"><Zap className="h-3 w-3" />SHORT</span>}
      </div>
      <div className="flex gap-3 pt-3">
        {!small && <Avatar name={v.creator_name} src={v.creator_avatar} size={34} />}
        <div className="min-w-0 flex-1">
          <p className="text-[14px] font-bold text-white leading-snug line-clamp-2">{v.title}</p>
          <p className="text-[12.5px] text-white/50 mt-1 hover:text-white/80 transition-colors">{v.creator_name}</p>
          <p className="text-[12.5px] text-white/50">{fmtViews(v.views)} views · {timeAgo(v.created_at)}</p>
        </div>
      </div>
    </Link>
  );
}

export function SCard({ v }) {
  return (
    <Link to={`/v/${v.slug}`} className="block group" data-testid={`mp-scard-${v.id}`}>
      <div className="mp-thumb aspect-[9/16]">
        {v.thumbnail_url
          ? <img src={v.thumbnail_url} alt={v.title} loading="lazy" className="h-full w-full object-cover" />
          : <div className="h-full w-full flex items-center justify-center"><Zap className="h-8 w-8 text-white/20" /></div>}
        <span className="mp-kw absolute inset-x-0 bottom-0 p-3 pt-8 bg-gradient-to-t from-black/85 to-transparent">
          <span className="block text-[13px] font-bold text-white leading-snug line-clamp-2">{v.title}</span>
          <span className="block text-[11px] text-white/60 mt-1">{fmtViews(v.views)} views</span>
        </span>
        <span className="absolute top-2 left-2 bg-black/70 text-emerald-400 text-[10px] font-extrabold px-2 py-0.5 rounded-md flex items-center gap-1"><Zap className="h-3 w-3" />SHORT</span>
      </div>
    </Link>
  );
}

export default function MPlayShell({ children, pills, pillActive, onPill, noPad }) {
  const [menu, setMenu] = useState(false);
  const [light, setLight] = useState(getMPTheme() === "light");
  useEffect(() => {
    const h = () => setLight(getMPTheme() === "light");
    window.addEventListener("mp_theme", h);
    return () => window.removeEventListener("mp_theme", h);
  }, []);
  return (
    <div className={`mp-root ${light ? "mp-light" : ""}`} data-testid="mplay-shell" data-theme={light ? "light" : "dark"}>
      <style>{MP_CSS}</style>
      <TopNav onMenu={() => setMenu(true)} />
      <SideNav open={menu} onClose={() => setMenu(false)} />
      <MobileNav />
      <main className={`lg:pl-[212px] pt-[60px] ${noPad ? "" : "pb-24 lg:pb-10"}`}>
        {pills && (
          <div className="sticky top-[60px] z-30 bg-[#070b09]/95 backdrop-blur px-3 sm:px-6 py-2.5">
            <Pills active={pillActive} onChange={onPill} />
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
